import React, { useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import enquiry from '../method/enquiry';
import crmEnquiry from '../method/lead';
import checkAnim from '../asset/checkAnim.gif';
import tickIcon from '../asset/check.JPG';
import '../style/pup1.css';
import { getImage } from '../module/api_init';

function EnquiryPopup({ props }) {
	const [booked, setbooked] = useState(0);
	const types = [
		'Get On-road Price', // 0
		'Get New Offer', // 1
		'Get EMI Offer', // 2
		'BOOK A TEST RIDE', // 3
		'ONLINE SERVICE BOOKING', // 4
		'Enquiry', // 5
		'Get Best Offers', // 6
		'Price in my city', // 7
		'Register Service', // 8
		'Insurance Enquiry', // 9
		'Find Career at Kalyani Motors', // 10
		'Book Kalyani Driving School', // 11
		'Enquiry New Dzire', // 12
		'Enquiry E Vitara', // 13
	];
	const { enquiryPopup } = props.state;
	const locationBasedVariant = window.location.pathname.includes("allcars") || window.location.pathname.includes("car")
	if (enquiryPopup === null) return null;

const specialCases = [5,8, 9, 10, 11, 12, 13];
const isSpecialCase = specialCases.includes(Number(enquiryPopup?.type));

const popupModelName = isSpecialCase
  ?  enquiryPopup.type === 5 ?  enquiryPopup.location: enquiryPopup.car
  : enquiryPopup.item.name;

const popupVariant = isSpecialCase
  ? enquiryPopup.car
  : locationBasedVariant
  ? enquiryPopup.item.name
  : enquiryPopup.item.varient.var_title || enquiryPopup.car;

	const popupChannel = enquiryPopup.type === 8 ? "Service" : isSpecialCase ? "Arena" : enquiryPopup.item.category_id === 1 ? "Nexa" : "Arena"

	const popupPurpose = isSpecialCase  ?  enquiryPopup.type === 5 ? "Branch Contact Enquiry" : enquiryPopup.car : types[enquiryPopup.type]
	const popupVehicle = isSpecialCase   ?  enquiryPopup.type === 5 ? "Branch Contact Enquiry" : enquiryPopup.car : enquiryPopup.item.body 

	return (
		<div className="pup1_a_a">
			<div className="pup1_a_b">
				{booked === 0 ? (
					<div className="pup1_a_c">{types[enquiryPopup.type]}</div>
				) : (
					<></>
				)}
				{booked !== 0 ? (
					booked === 1 ? (
						<img
							alt="Kalyani Motors Leading Maruti Suzuki Dealership"
							className="pup1_a_d"
							src={checkAnim}
						/>
					) : (
						<img
							alt="Kalyani Motors Leading Maruti Suzuki Dealership"
							className="pup1_a_d"
							src={tickIcon}
						/>
					)
				) : (
					<form
						id="booking_form"
						onSubmit={async (e) => {
							e.preventDefault();
							if (e.target.phone.value.length !== 10) {
								alert('Not a valid phone number');
								return;
							}
							setbooked(1);
							const body = {
								name: e.target.name.value,
								phone: e.target.phone.value,
								email: e.target.email ? e.target.email.value : '',
								city: e.target.city ? e.target.city.value : '',
								location: localStorage.getItem('location'),
								vehicle: e.target.carName.value,
								purpose: types[enquiryPopup.type],
							};

							const crmEnquiryBody = {
								customerName:e.target.name.value,
								mobileNumber: e.target.phone.value,
								emailId: e.target.email ? e.target.email.value : '',
								modelName:popupModelName,
								variant: popupVariant === undefined ? "Branch Contact Enquiry" : popupVariant ,
								location:localStorage.getItem('location'),
								channel: popupChannel,
								crmSource: "Google Ads",
								leadType: "Website",
								isPrimary: "Yes",
								leadDate: new Date().toLocaleDateString(),
								transUniqueId: 0,
								purpose: popupPurpose,
								vehicle: popupVehicle,
							}
              //enquiry(body),
							await Promise.all([crmEnquiry(crmEnquiryBody)])
							setTimeout(() => {
								setbooked(0);
								props.setState({ enquiryPopup: null });
							}, 3000);
						}}
					>
						<input
							placeholder="Name"
							className="pup1_a_e"
							type="text"
							required
							id="name"
						/>
						{(enquiryPopup.type === 12 || enquiryPopup.type === 13) && (
							<>
								<input
									placeholder="Email"
									className="pup1_a_e"
									type="email"
									id="email"
									required
								/>
								<input
									placeholder="City"
									className="pup1_a_e"
									type="text"
									id="city"
									required
								/>
							</>
						)}
						<input
							placeholder="Phone Number"
							className="pup1_a_e"
							type="text"
							required
							id="phone"
						/>
						<input
							type="text"
							className="pup1_a_e"
							value={types[enquiryPopup.type]}
							id="carName"
							disabled
						/>
						<div  className = "pup_checkbox_container" >
								<input
									type="checkbox"
									required
									id="checkbox"
									className='pup_checkbox'		
								/>
								<label htmlFor="checkbox" className='pup_checkbox_label'>
									<span style={{ fontWeight: '600' }}>Disclaimer:</span> I authorize Kalyani Motors to send notifications via SMS, Kalyani Super App, WhatsApp, Email and RCS.
								</label>
							</div>						
						<button type="submit" className="pup1_a_f">
							{types[enquiryPopup.type]}
						</button>
					</form>
				)}
				{booked !== 0 ? (
					<p className="pup1_a_g">
						Thank you for your interest in {enquiryPopup.car}. We will get in
						touch with you soon...
					</p>
				) : (
					''
				)}
				<div
					onClick={() => props.setState({ enquiryPopup: null }, setbooked(0))}
					className="pup1_a_h"
				>
					Close
				</div>
			</div>
		</div>
	);
}


function CarPopup({ props }) {
	const count = props.state.selectedImage;
	const { car, versionCount, colorCount } = props.state;
	if (count === null) return null;
	return (
		<div
			style={{
				width: '100vw',
				display: 'flex',
				position: 'fixed',
				top: 0,
				left: 0,
				height: '100vh',
				justifyContent: 'center',
				alignItems: 'center',
			}}
		>
			<div
				style={{
					maxWidth: 800,
					width: '100%',

					position: 'fixed',
					boxShadow: '1px 1px 4px gray',
					background: 'white',
				}}
			>
				<div
					style={{
						fontWeight: 'bold',
						fontSize: 22,
						display: 'flex',
						justifyContent: 'end',
					}}
				>
					<div
						style={{
							cursor: 'pointer',
							padding: '10px 20px',
							paddingBottom: 2,
						}}
						onClick={() => props.setState({ selectedImage: null })}
					>
						X
					</div>
				</div>
				<Carousel useKeyboardArrows>
					{car.varients[versionCount].products[colorCount].images.map((img) => (
						<img
							alt="Kalyani Motors Leading Maruti Suzuki Dealership"
							src={getImage(img.images)}
							style={{
								maxWidth: 700,
								width: '100%',
								objectFit: 'cover',
								border: '1px solid #ccc',
								borderRadius: 8,
							}}
						/>
					))}
				</Carousel>
			</div>
		</div>
	);
}

export { EnquiryPopup, CarPopup };
